import React, { useEffect, useState } from "react";
import Box from "../Box";
import styles from "./styles/QModal.module.css";
import log from "cslog";
import { SlateViewer } from "../../../../juntion";

function QModal({ db, gs, device, action, setAction }) {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (action.type === "drawer") {
            const timer = setTimeout(() => {
                setOpen(true);
            }, 1);
            return () => clearTimeout(timer);
        }
    }, [action]);

    const closeDrawer = () => {
        setOpen(false);
        setTimeout(() => {
            setAction({
                type: "none",
            });
        }, 300);
    };

    const width = 80;

    return (
        <div className={styles.body_wrapper}>
            <div className={styles.wrapper} style={{}}>
                <div
                    className={styles.closeBtn}
                    onClick={closeDrawer}
                    onMouseDown={closeDrawer}
                >
                    <i className="fas fa-times" />
                </div>
                <div className={styles.content}>
                    <SlateViewer
                        id="modal"
                        key={JSON.stringify(action)}
                        input={{
                            // ...input,
                            html: action?.params?.html,
                        }}
                        // styles={styles_decoded}
                        // dydb={dydb}
                        dydb={{}}
                    />
                </div>
            </div>
            <div className={styles.outArea} onClick={closeDrawer}></div>
        </div>
    );
}

export default QModal;
